import { Popover, PopoverProps } from '../Popover'

export const Drawer: React.FC<PopoverProps> = (props) => <Popover {...props} />
